import React from "react";
import { isMobile } from "react-device-detect";
import { WebLoderTop } from "../../config/config";
function Loader({ margin = "auto", MarginTop = "auto" }) {
  return (
    <img
      style={{
        position: "absolute",
        top: isMobile ? 0 : WebLoderTop,
        left: 0,
        right: 0,
        bottom: 0,
        margin: margin,
        marginTop: MarginTop,
      }}
      src={require("./images/imgLoader.gif")}
      alt=""
    />
  );
}
export default Loader;
